import React from 'react';
import './DropdownNav.scss';
import { triggerDataLayerOnCtaClick } from '../../../../own-days/helper';

const DropdownNav = () => {
  return (
    <div className="odDropdownNav">
      <a
        className="odDropdownNav__navlink"
        href="/sg/en/customer/account"
        onClick={() => triggerDataLayerOnCtaClick('My Orders')}
      >
        <div className="odDropdownNav__nav">
          <div className="odDropdownNav__navTitle">
            <img
              alt="my orders"
              className="odDropdownNav__navIcon"
              src="https://static.lenskart.com/media/owndays/minified/my-orders.webp"
            />
            My Orders
          </div>
          <img
            alt="arrow"
            className="odDropdownNav__arrowIcon"
            src="https://static.lenskart.com/media/owndays/minified/arrow-right.webp"
          />
        </div>
      </a>
      <a
        className="odDropdownNav__navlink"
        href="/sg/en/customer/account/edit"
        onClick={() => triggerDataLayerOnCtaClick('Account Information')}
      >
        <div className="odDropdownNav__nav">
          <div className="odDropdownNav__navTitle">
            <img
              alt="account information"
              className="odDropdownNav__navIcon"
              src="https://static.lenskart.com/media/owndays/minified/profile.webp"
            />
            Account Information
          </div>
          <img
            alt="arrow"
            className="odDropdownNav__arrowIcon"
            src="https://static.lenskart.com/media/owndays/minified/arrow-right.webp"
          />
        </div>
      </a>
    </div>
  );
};

export default DropdownNav;
